// extracted by mini-css-extract-plugin
export default {"NotificationText":"ReconnectNotification_NotificationText__G9Et5"};